import {useEffect} from "react";
import {observer} from "mobx-react-lite";
import {useStores} from "stores/rootStore";
import {useLanguage} from "i18n/LanguageProvider";

// Stores the UI language on the account — at session start and on every switch —
// since the backend writes the account's emails in it.
export const AccountLanguageSync = observer(() => {
    const {user} = useStores();
    const {lang} = useLanguage();
    const due = user.needsLocaleSync(lang);

    useEffect(() => {
        if (due) user.syncLocale(lang);
    }, [due, lang, user]);

    return null;
});
